export default [
  { value: "Normal", key: 0 },
  { value: "Limited", key: 1 },
  { value: "Legend", key: 2 },
];
